import React from "react";

import {
  List,
  DataTable,
  TextField,
  TextInput,
  NumberInput,
  Edit,
  SimpleForm,
  EditButton,
  Create,
  required,
  TopToolbar,
  ColumnsButton,
  CreateButton,
  FilterButton,
  Pagination,
} from "react-admin";
import { WineColourField, WineColorInput } from "../lib/wineColour";

const varietalFilter = [
  <TextInput label="Name" source="name" alwaysOn resettable />,
];

export const VarietalList = () => (
  <List
    perPage={100}
    pagination={<Pagination rowsPerPageOptions={[100, 200, 500, 1000]} />}
    filters={varietalFilter}
    actions={
      <TopToolbar>
        <FilterButton />
        <CreateButton />
        <ColumnsButton />
      </TopToolbar>
    }
    sort={{ field: "name", order: "ASC" }}
    storeKey={false}
    empty={false}
  >
    <DataTable rowClick={false} bulkActionButtons={false}>
      <DataTable.Col source="id" label="ID">
        <TextField source="id" label="ID" />
      </DataTable.Col>
      <DataTable.Col source="name" label="Name">
        <TextField source="name" label="Name" />
      </DataTable.Col>
      <DataTable.Col source="is_red" label="Color">
        <WineColourField source="is_red" label="Color" />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export const VarietalEdit = () => (
  <Edit redirect="list">
    <SimpleForm>
      <NumberInput source="id" readOnly />
      <TextInput source="name" label="Name" validate={required()} />
      <WineColorInput source="is_red" label="Color" />
    </SimpleForm>
  </Edit>
);

export const VarietalCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <NumberInput label="ID" source="id" readOnly />
      <TextInput source="name" label="Name" validate={required()} />
      <WineColorInput source="is_red" label="Color" />
    </SimpleForm>
  </Create>
);
